export default "__VITE_ASSET__AhovbU45__"